import React from "react";

import MuiAvatar from "@mui/material/Avatar";
import { AvatarProps as MuiAvatarProps } from "@mui/material/Avatar/Avatar";
import styled from "@mui/material/styles/styled";

import Stack from "@readai/pulse/components/Stack";

export type AvatarSize = "xs" | "sm" | "md" | "lg" | "xl";

type StyledAvatarProps = MuiAvatarProps & { size: AvatarSize };

const AVATAR_SIZE_MAP: { [key in AvatarSize]: React.CSSProperties["height"] } =
  {
    xs: "24px",
    sm: "32px",
    md: "36px",
    lg: "40px",
    xl: "60px",
  };

export const AvatarContainer = styled(Stack)(({ theme, onClick }) => ({
  position: "relative",
  "& .avatar__edit-mask": {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    transition: "all 0.3s ease-out",
    opacity: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.40)",
    borderRadius: "10px",
    "& .avatar__edit-icon": {
      color: "white",
      fontSize: theme.sizes.icon.small,
    },
  },
  ...(onClick && {
    "&:hover": {
      cursor: "pointer",
      "& .avatar__edit-mask": {
        opacity: 1,
      },
    },
  }),
}));

export const StyledAvatar = styled<React.FC<StyledAvatarProps>>(MuiAvatar, {
  shouldForwardProp: (propName) => propName != "size",
})(({ theme, onClick, size }) => ({
  borderRadius: "10px",
  fontFamily: theme.typography.fontFamilySecondary,
  fontWeight: "600",
  fontSize: size === "xl" ? "24px" : "13px",
  height: AVATAR_SIZE_MAP[size],
  width: AVATAR_SIZE_MAP[size],
  ...(onClick && {
    "&:hover": {
      cursor: "pointer",
    },
  }),
  "&.focused": {
    border: "2px solid",
    borderColor: theme.palette.outline.brand,
  },
}));
